import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatSort, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { FormControl } from '@angular/forms';
import { findLast } from '@angular/compiler/src/directive_resolver';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-bank-account',
  templateUrl: './bank-account.component.html',
  styleUrls: ['./bank-account.component.css']
})
export class BankAccountComponent implements OnInit {

  acctList = [];
  countryList = [];
  currencyList = [];
  acctDetail = '';

  model = {
    'table_name': 'bank_account', 'account_id': '0', 'bank_acct_number': '', 'acct_number': '', 'account_name': '',
    'bank_name': '', 'account_name_en': '', 'bank_name_en': '', 'iban': '', 'start_date': '', 'currency': '0',
    'key': 'account_id', 'flag': 'new', 'country_id': '0', 'comment': ''
  };

  date_model = { 'start_date': new Date(this.applicationConstants.business_cycle.start_date) };

  base_model = {
    'table_name': 'acct_base', 'baseline_id': '0', 'base_date': '', 'acct_number': '',
    'main_acct_no': this.applicationConstants.main_acct_config['bank'], 
    'acct_type_no': this.applicationConstants.acct_type_config['bank'], 'key': 'baseline_id', 'flag': 'new', 
    'baseline_amount': '0', 'comment': ''
  };

  sub_acct_model = {
    'table_name': 'sub_acct', 'sub_acct_id': '0', 
    'acct_type_no': this.applicationConstants.acct_type_config['bank'], 
    'main_acct_no': this.applicationConstants.main_acct_config['bank'], 'sub_acct_name': '',
    'sub_acct_name_en': '', 'acct_number': '', 'parent_acct':'', 'acct_level': '0', 'is_leaf': '1', 'is_cc':'1', 
    'tax_acct': '0', 'emp_no': '0', 'cc_no': '0', 'key': 'sub_acct_id', 'flag': 'new', 'comment': '', 
    'auto_set': '0', 'set_type': 'count'
  };

  Success_Msg; Error_Msg; 
  Belong_To_Msg; Acct_No_Msg; 
  Bank_Name_Msg; Acct_Name_Msg; 
  Currency_Msg; Country_Msg;
  Acct_No_Exist;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<BankAccountComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Belong_To_Msg').subscribe((res: string) => {
      this.Belong_To_Msg = res;
    });

    translate.get('Acct_No_Msg').subscribe((res: string) => {
      this.Acct_No_Msg = res;
    });

    translate.get('Bank_Name_Msg').subscribe((res: string) => {
      this.Bank_Name_Msg = res;
    });

    translate.get('Acct_Name_Msg').subscribe((res: string) => {
      this.Acct_Name_Msg = res;
    });

    translate.get('Acct_No_Msg').subscribe((res: string) => {
      this.Acct_No_Msg = res;
    });

    translate.get('Currency_Msg').subscribe((res: string) => {
      this.Currency_Msg = res;
    });

    translate.get('Country_Msg').subscribe((res: string) => {
      this.Country_Msg = res;
    });

    translate.get('Acct_No_Exist').subscribe((res: string) => {
      this.Acct_No_Exist = res;
    });

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });
  }

  ngOnInit() {
    let obj;

    // get not leaf bank accts
    let parent_acct = this.applicationConstants.main_acct_config['bank'];
    obj = { cmd: 'getAccountList', parent_acct: parent_acct, include_parent: true, add_leaf: false };
    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.acctList = data.data['list'];

        if (this.dialog_data == null) {
          if (this.acctList.length > 0) {
            parent_acct = this.acctList[0]['acct_number'];
            this.acctDetail = parent_acct + ' - ' + this.acctList[0]['sub_acct_name'] + ' - ' + 
              this.acctList[0]['sub_acct_name_en'];
          }
          else 
            this.acctDetail = parent_acct + ' - الحسابات البنكية - Bank Accounts';

          this.onChangeSearch("", parent_acct);
        }
      });
    
    // this.acctList = this.utils.getAcctList(parent_acct, false);
    // console.log(this.acctList);

    let query = this.queryList.all_country;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.countryList = data.data['list'];
      });

    query = this.queryList.all_currency;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.currencyList = data.data['list'];
      });

    if (this.dialog_data != null) {
      // document.getElementById("base").style.display = 'none';
      this.model = this.dialog_data['0'];
      this.base_model = this.dialog_data['1'];

      this.sub_acct_model['sub_acct_name'] = this.model['account_name'];
      this.sub_acct_model['sub_acct_name_en'] = this.model['account_name_en'];
      this.sub_acct_model['acct_number'] = this.model['acct_number'];
      this.sub_acct_model['comment'] = this.model['comment'];
      this.sub_acct_model['flag'] = 'update';

      let query = "SELECT * FROM `sub_acct` WHERE `acct_number` = '" + this.model['acct_number'] + "'";
      let obj = { cmd: 'getList', query: query };
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          if (data.data['list'].length > 0) {
            let sub_acct = data.data['list'][0];
            this.sub_acct_model['sub_acct_id'] = sub_acct['sub_acct_id'];
            this.sub_acct_model['parent_acct'] = sub_acct['parent_acct'];
            this.sub_acct_model['acct_level'] = sub_acct['acct_level'];
            // this.sub_acct_model['is_leaf'] = sub_acct['is_leaf'];
            // this.sub_acct_model['is_cc'] = sub_acct['is_cc'];

            // get parent acct detail
            query = this.queryList.all_subAcct + " AND `acct_number` = '" + sub_acct['parent_acct'] + "'";
            obj = { cmd: 'getList', query: query };

            this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
              .subscribe(data => {
                this.applicationConstants.appComp.hideBusyCursor();

                let parent_acct = data.data['list'][0];
                this.acctDetail = sub_acct['parent_acct'] + ' - ' + parent_acct['sub_acct_name'] + ' - ' + 
                  parent_acct['sub_acct_name_en'];
                console.log(parent_acct);
                // console.log((document.getElementById('parent_acct') as HTMLInputElement));
                // (document.getElementById('search_value_0') as HTMLInputElement).value = sub_acct['parent_acct'] + ' - ' + 
                //   parent_acct['sub_acct_name'] + ' - ' + parent_acct['sub_acct_name_en'];
              });
          }
        });

        // get base detail
        query = "SELECT * FROM `acct_base` WHERE `acct_number` = '" + this.model['acct_number'] + 
          "' AND `base_date` = (SELECT MIN(`base_date`) FROM `acct_base` WHERE `acct_number` = '" + this.model['acct_number'] + 
          "')";
        obj = { cmd: 'getList', query: query };
        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();

            let result = data.data['list'];
            if (result.length > 0) {
              this.base_model['flag'] = 'update';
              this.base_model['key'] = 'baseline_id';
              this.base_model['baseline_id'] = result[0]['baseline_id'];
              this.base_model['base_date'] = result[0]['base_date'];
              this.date_model['start_date'] = new Date(result[0]['base_date']);
              this.base_model['baseline_amount'] = result[0]['baseline_amount'];
            }
          });
    } 
  }

  onChangeSearch = function (acct_number: string, parent_acct: string) {
    console.log(acct_number);

    if (acct_number != '' || parent_acct != '') {
      this.sub_acct_model['parent_acct'] = "";
      this.sub_acct_model['acct_level'] = "0";

      if (acct_number != '')
        this.sub_acct_model['parent_acct'] = acct_number;
      else if (parent_acct != '') 
        this.sub_acct_model['parent_acct'] = parent_acct;

      // if (this.sub_acct_model['parent_acct'] != "") {
      var element;
      for (let index = 0; index < this.acctList.length; index++) {
        element = this.acctList[index];
        if (element.acct_number == this.sub_acct_model['parent_acct']) {
          this.sub_acct_model['acct_level'] = String(Number(element.acct_level) + 1);
          break;
        }
      }
      if (this.sub_acct_model['acct_level'] == "0") 
        this.sub_acct_model['acct_level'] = String(Number(this.sub_acct_model['acct_level']) + 1);

      if (this.model['account_id'] == '0') {
        this.model['acct_number'] = "";
        
        let query = "SELECT COALESCE(MAX(CAST(`acct_number` AS UNSIGNED)), 0) AS `acct_number` FROM `sub_acct` WHERE `parent_acct` = '" + 
          this.sub_acct_model['parent_acct'] + "'";
        let obj = { cmd: 'getList', query: query };
        
        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();
            
            let result = Number(data.data['list'][0]['acct_number']);
            if (result == 0) 
              this.model['acct_number'] = this.sub_acct_model['parent_acct'] + "001";
            else
              this.model['acct_number'] = String(result + 1);
          });
        // }
      }
      
    }
  }

  changeAcctNumber() {
    if (this.model['acct_number'] == "" && this.sub_acct_model['parent_acct'] != "")
      this.onChangeSearch("", this.sub_acct_model['parent_acct']);
  }

  add() {
    if (this.sub_acct_model['parent_acct'] == '') {
      alert(this.Belong_To_Msg);
      return;
    }

    if (this.model['acct_number'] == '') {
      alert(this.Acct_No_Msg);
      return;
    }

    if (this.model['bank_name'] == '') {
      alert(this.Bank_Name_Msg);
      return;
    }
     
    if (this.model['account_name'] == '') {
      alert(this.Acct_Name_Msg);
      return;
    }
      
    if (this.model['bank_acct_number'] == '') {
      alert(this.Acct_No_Msg);
      return;
    }
     
    if (this.model['currency'] == '0') {
      alert(this.Currency_Msg);
      return;
    }
      
    if (this.model['country_id'] == '0') {
      alert(this.Country_Msg);
      return;
    }

    let values = [];
    let obj;

    this.model['start_date'] = this.date_model['start_date'].getFullYear() + "-" + 
      (this.date_model['start_date'].getMonth() + 1) + "-" + this.date_model['start_date'].getDate();
    values.push(this.model);

    //add sub acct
    this.sub_acct_model['sub_acct_name'] = this.model['account_name'];
    this.sub_acct_model['sub_acct_name_en'] = this.model['account_name_en'];
    this.sub_acct_model['acct_number'] = this.model['acct_number'];
    this.sub_acct_model['comment'] = this.model['comment'];

    values.push(this.sub_acct_model);

    this.base_model['base_date'] = this.date_model['start_date'].getFullYear() + "-" +
      (this.date_model['start_date'].getMonth() + 1) + "-" + this.date_model['start_date'].getDate() + 
      " 00:00:00";
      // ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds();

    this.base_model['acct_number'] = this.model['acct_number'];
    values.push(this.base_model);

    if (this.model['account_id'] == '0') {
  
      let query = "SELECT * FROM `sub_acct` WHERE `acct_number` = '" + this.model['acct_number'] + "'";
      obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          
          let result = data.data['list'];
          if (result.length > 0) 
            alert(this.Acct_No_Exist);  
          else {
            // save customer
            obj = { cmd: 'add', values: values };

            this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
              .subscribe(data => {
                this.applicationConstants.appComp.hideBusyCursor();
                
                if (data.status['type'] == 'success') {
                  alert(this.Success_Msg);
                  this.dialog_data = { 'op_type': 'success' };
                  this.dialogRef.close(this.dialog_data);
                }
                else
                  alert(this.Error_Msg);

              });
          }
        });
    }
    else {
      obj = { cmd: 'updateAdv', values: values };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          //console.log(data);
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.dialog_data = { 'op_type': 'success' };
            this.dialogRef.close(this.dialog_data);
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
  }

  cancel() {
    this.dialog_data = { 'op_type': 'cancel' };
    this.dialogRef.close(this.dialog_data);
  }

}

